import { render, staticRenderFns } from "./PuhuoTables.vue?vue&type=template&id=4a14b85e&scoped=true"
import script from "./PuhuoTables.vue?vue&type=script&lang=js"
export * from "./PuhuoTables.vue?vue&type=script&lang=js"
import style0 from "./PuhuoTables.vue?vue&type=style&index=0&id=4a14b85e&prod&lang=scss&scoped=true"
import style1 from "./PuhuoTables.vue?vue&type=style&index=1&id=4a14b85e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a14b85e",
  null
  
)

export default component.exports